import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ['image']

    connect() {
        this.url = this.element.dataset.url;
        this.id = this.element.dataset.id;
        this.action = this.element.dataset.context;
        this.isProcessing = false;
    }

    addToCart(event) {
        event.preventDefault();
        if (this.isProcessing) {
            return;
        }
        this.isProcessing = true;
        this.buildAjax(this.url, this.id);
    }

    buildAjax(url, id) {
        let _self = this
        $.ajax({
            data: {id: id},
            url: url,
            method: 'POST',
            success: function (result) {
                _self.successAjax(result)
            },
            complete: function () {
                _self.isProcessing = false;
            }
        });
    }

    successAjax(result) {
        let modal = $('#checkout-modal');
        modal.modal('show');

        let successMessage = $('#success');
        let failMessage = $('#fail');

        if (result.success === false) {
            successMessage.hide();
            failMessage.text(result.message);
            failMessage.addClass('cart-delivery-hint');
            failMessage.show();

            return;

        } else {
            successMessage.show();
            failMessage.hide();
        }

        EventManager.fire('item-added', result.cart);

        let event = {
            event: 'eec.add',
            eventData: result.variant,
            action: this.action,
        }


        fbq('track', 'AddToCart', {
            content_ids: [result.variant.id],
            content_type: 'product',
            value: result.variant.price,
            currency: 'EUR'
        });
        ttq.track('AddToCart', {
            "contents": [
                {
                    "content_id": result.variant.id, // string. ID of the product. Example: "1077218".
                    "content_type": "product", // string. Either product or product_group.
                    "content_name": result.variant.name, // string. The name of the page or product. Example: "shirt".
                    "content_category": result.variant.category, // string. The category of the page or product. Example: "apparel".
                    "price": result.variant.price, // number. The price of a single item. Example: 25.
                    "num_items": result.variant.quantity // number. The number of items. Example: 4.
                }
            ],
            "value": result.variant.price, // number. Value of the order or items sold. Example: 100.
            "currency": "EUR", // string. The 4217 currency code. Example: "USD".
        },{
            "event_id": result.tiktokEventId,
        });


        EventManager.fire('gtm-event', event);
    }
}
